async function fetchEntry(type, entryID) {

    let resourceURL = `https://apiapi.ombligo.com/n_contentful/entry/${type}/${entryID}`;
    // const headers = {
    //     Authorization: `Bearer ${accessToken}`
    // };

    try {
        const response = await fetch(resourceURL);
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Likely No Data to pull:', error);
    }
}

async function retrieveLinkedTechTalks(resources) {    
    for (const resource of resources) {
        let resourceID = resource.sys.id;
        let entry = await fetchEntry("entries", resourceID);
        if (entry && entry.fields) {
            var resourceData = entry.fields;
            await setupCTOContentResources(resourceData);
        }
    }
}

async function retrieveLinkedEntries(resources) {    
    let resourceData = [];
    for (const resource of resources) {
        let resourceID = resource.sys.id;
        let entry = await fetchEntry("entries", resourceID);
        if (entry && entry.fields) {
            resourceData.push(entry.fields);
        }
    }
    return resourceData;
}

function parseRichText(node, classlist = null) {
    if (node.nodeType === 'text') {
        let text = node.value;
        if (node.marks) {
            node.marks.forEach(mark => {
                if (mark.type === 'bold') {
                    text = `<strong>${text}</strong>`;
                }
                if (mark.type === 'italic') {
                    text = `<em>${text}</em>`;
                }
                if (mark.type === 'underline') {
                    text = `<u>${text}</u>`;
                }
                if (mark.type === "heading-3") {
                    text = `<h3>${text}</h3>`;
                }
            });
        }
        return text;

    } else if (node.nodeType === 'hyperlink') {
        return `<a class="contentfulHyperLink" title="${node.content.map(childNode => parseRichText(childNode, classlist)).join('')}" href="${node.data.uri}">${node.content.map(childNode => parseRichText(childNode, classlist)).join('')}</a>`;
    } else if (node.nodeType === 'paragraph') {
        if (classlist) {
            return `<p class="${classlist}">${node.content.map(childNode => parseRichText(childNode, classlist)).join('')}</p>`;
        } else {
            return `<p>${node.content.map(childNode => parseRichText(childNode, classlist)).join('')}</p>`;
        }
    } else if (node.nodeType === 'document') {
        return node.content.map(childNode => parseRichText(childNode, classlist)).join('');
    }
    return '';
}



function richText(obj) {
    let response = '';
    obj.forEach(node => {
        response += parseRichText(node);
    });
    return response;
}


    async function getContentfulCollectionUtil(collectionHandle) {

        const contentful = `https://apiapi.ombligo.com/n_contentful/collection/${collectionHandle}`;
        // const headers = {
        //     Authorization: `Bearer ${accessToken}`
        // };

        try {
            const response = await fetch(contentful);
            const data = await response.json();
            return data;
        } catch (error) {
            console.log('Likely No Data:', error);
        }
    }
 
    async function getContentfulSpecificType(contentType, queryFieldKey, queryFieldVal) {


        const contentful = `https://apiapi.ombligo.com/n_contentful/specific/${contentType}/${queryFieldKey}/${queryFieldVal}/`;

    
        try {
            const response = await fetch(contentful);
            const data = await response.json();
            return data;
        } catch (error) {
            console.log('Likely No Data:', error);
        }
    }
    
    async function getContentfulTypeSearch(contentType, queryFieldKey, queryFieldVal) {
        if (!queryFieldVal || !contentType || !queryFieldKey) {
            return null;
        }

        const apiUrl = `https://apiapi.ombligo.com/n_contentful/search/${contentType}/${queryFieldKey}/${queryFieldVal}/`;
        
        try {
            const response = await fetch(apiUrl);
            const data = await response.json();
            return data;
        } catch (error) {
            console.log('Likely No Data:', error);
        }
    }
        

async function getAllEntriesByType(contentType, limit = 200, skip = 0, order = '-sys.createdAt') {
    const apiUrl = `https://apiapi.ombligo.com/n_contentful/all/${contentType}/?limit=${limit}&skip=${skip}&order=${encodeURIComponent(order)}`;
    
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`Error fetching entries of type ${contentType}:`, error);
        throw error;
    }
}